import { useAccountStorage, useOrganizationStorage } from '../../../../../../AppClients';
import { organizationTypeEntityName } from '../../../../../../backend/config/classifiers/OrganizationTypeClassifier/shared';
import { orgIdPrefixForAlertService } from '../../../../../../backend/features/organizations/shared';
import { getActiveAccountsFilter, getOrganizationIdsWithRoleHavingPermission, requireAnySystemPermission, requireOrgPermission, } from '../../../../../../backend/features/permissions/shared';
import { EntityDetailsSimpleItem } from '../../../../../../ui/components/EntitySectionList';
import { showImageUploadDialog } from '../../../../../../ui/components/UploadImageDialog';
import { showDeleteEntityDialog } from '../../../../../../ui/components/showDeleteEntityDialog';
import { useContactManagementTranslation, useUserState } from '../../../../../../ui/hooks';
import { ContactManagementConfigContext } from '../../../../../../ui/providers';
import { formatPhoneNumber } from '@juvare/common-phone-number';
import { handleErrorDialog, showConfirmDialog } from '@juvare/common-web-ui/DialogHelper';
import { ModalSlideoutContent, ModalSlideoutHeader, ModalSlideoutTitleArea, ModalSlideoutTopBar, ModalSlideoutTopBarDefaultActions, } from '@juvare/common-web-ui/ModalSlideout';
import { handleErrorSnackbar, showInfoSnackbar } from '@juvare/common-web-ui/SnackbarHelper';
import { Image } from '@juvare/platform-sdk-react/ui/components';
import { getSettings } from '@juvare/platform-sdk-react/ui/features/editable-settings';
import { useAttachmentClient, usePlatformLoader, useStorageList } from '@juvare/platform-sdk-react/ui/hooks';
import { Box, Button, CircularProgress, Typography, useTheme } from '@mui/material';
import React, { useContext } from 'react';
import { PieChart } from 'react-minimal-pie-chart';
import { useSelector } from 'react-redux';
import { OrganizationSectionList } from '../../OrganizationSectionList';
import { getStatusAndRoleInNewOrganization } from '../utils';
export const organizationSlideoutButtonIds = {
    messageMembers: 'message-members',
    messageAdmins: 'message-admins',
    uploadLogo: 'upload-logo',
    delete: 'delete',
};
export const OrganizationDetails = (props) => {
    var _a, _b, _c, _d, _e;
    const { notificationConfig } = useContext(ContactManagementConfigContext);
    const settings = useSelector(getSettings);
    const { appContext } = React.useContext(ContactManagementConfigContext);
    const { onStatelessReload } = usePlatformLoader({ appContext });
    const userState = useUserState();
    const orgRoleMap = settings.orgRoleMap;
    const orgStatusMap = settings.orgStatusMap;
    const theme = useTheme();
    const menuItems = (_c = (_b = (_a = props.options) === null || _a === void 0 ? void 0 : _a.menuItems) === null || _b === void 0 ? void 0 : _b.call(_a, { organization: props.organization })) !== null && _c !== void 0 ? _c : [];
    const storageClientOrganization = useOrganizationStorage();
    const storageClientAccount = useAccountStorage();
    const organizationAttachmentStorage = useAttachmentClient();
    const { t } = useContactManagementTranslation();
    const { data: organizationTypes, isLoading: organizationTypesIsLoading } = useStorageList(organizationTypeEntityName, {});
    const organizationType = (organizationTypes === null || organizationTypes === void 0 ? void 0 : organizationTypes.rows.length) !== 0 && props.organization.data.type
        ? organizationTypes === null || organizationTypes === void 0 ? void 0 : organizationTypes.rows.find((type) => type.columns.name === props.organization.data.type)
        : undefined;
    const showOrganizationTypes = Boolean((organizationTypes === null || organizationTypes === void 0 ? void 0 : organizationTypes.rows.length) && (organizationTypes === null || organizationTypes === void 0 ? void 0 : organizationTypes.rows.some((row) => row.columns.status === 'active')));
    const getOrganizationTypeName = () => {
        if (!organizationType) {
            return '';
        }
        return (organizationType === null || organizationType === void 0 ? void 0 : organizationType.columns.status) === 'active'
            ? organizationType === null || organizationType === void 0 ? void 0 : organizationType.columns.name
            : `${organizationType === null || organizationType === void 0 ? void 0 : organizationType.columns.name} (${organizationType === null || organizationType === void 0 ? void 0 : organizationType.columns.status})`;
    };
    const [organizationStatuses, setOrganizationStatuses] = React.useState([]);
    const allowInfo = requireAnySystemPermission(userState, 'manage-organizations') ||
        requireOrgPermission(userState, props.organization.id, 'manage-organization');
    const allowMembers = requireAnySystemPermission(userState, 'manage-accounts') ||
        requireOrgPermission(userState, props.organization.id, 'manage-members');
    const allowMessage = requireAnySystemPermission(userState, 'manage-organizations') ||
        requireOrgPermission(userState, props.organization.id, 'view-and-message-members') ||
        requireOrgPermission(userState, props.organization.id, 'create-notifications');
    const allowDelete = props.organization.parentId ? allowInfo : requireAnySystemPermission(userState, 'manage-organizations');
    React.useEffect(() => {
        if (allowMembers) {
            // TODO need a better way to calculate aggregate data
            storageClientAccount
                .list({
                filter: [
                    ...getActiveAccountsFilter(userState),
                    {
                        column: 'orgStatus',
                        op: 'overlap',
                        value: Object.entries(orgStatusMap).map(([value]) => `${props.organization.id}_${value}`),
                    },
                ],
            })
                .then((response) => {
                const organizationStatuses = [];
                response.rows.forEach((account) => {
                    const foundOrgStatus = account.columns.orgStatus.find((status) => status.startsWith(props.organization.id));
                    if (foundOrgStatus) {
                        const [, statusName] = foundOrgStatus.split('_');
                        const foundChartStatus = organizationStatuses.findIndex((status) => status.key === statusName);
                        if (foundChartStatus === -1) {
                            const status = orgStatusMap[statusName];
                            organizationStatuses.push({
                                title: status ? status.label : t('common.unknown'),
                                key: statusName,
                                value: 1,
                                color: status ? status.color : theme.palette.primary.dark,
                            });
                        }
                        else {
                            organizationStatuses[foundChartStatus].value += 1;
                        }
                    }
                });
                setOrganizationStatuses(organizationStatuses);
            })
                .catch(handleErrorSnackbar);
        }
        else {
            setOrganizationStatuses([]);
        }
    }, [props.organization.id, storageClientAccount, theme, orgStatusMap, allowMembers, t, userState]);
    if (props.organization) {
        if ((notificationConfig === null || notificationConfig === void 0 ? void 0 : notificationConfig.onOrganizationNotificationSend) && allowMessage) {
            menuItems.push({
                'data-test': 'message-members',
                id: organizationSlideoutButtonIds.messageMembers,
                label: t('panels.organizations.messageMembers'),
                onClick: () => { var _a; return (_a = notificationConfig === null || notificationConfig === void 0 ? void 0 : notificationConfig.onOrganizationNotificationSend) === null || _a === void 0 ? void 0 : _a.call(notificationConfig, orgIdPrefixForAlertService + props.organization.id); },
            });
            menuItems.push({
                'data-test': 'message-admins',
                label: t('panels.organizations.messageAdmins'),
                id: organizationSlideoutButtonIds.messageAdmins,
                onClick: () => {
                    storageClientAccount
                        .list({
                        filter: [
                            {
                                column: 'orgRole',
                                op: 'overlap',
                                value: getOrganizationIdsWithRoleHavingPermission([props.organization.id], orgRoleMap, 'manage-members'),
                            },
                        ],
                    })
                        .then((response) => {
                        var _a;
                        return (_a = notificationConfig === null || notificationConfig === void 0 ? void 0 : notificationConfig.onOrganizationNotificationSend) === null || _a === void 0 ? void 0 : _a.call(notificationConfig, orgIdPrefixForAlertService + props.organization.id, response.rows.map((resp) => resp.id));
                    })
                        .catch(handleErrorSnackbar);
                },
            });
        }
        if (allowInfo) {
            menuItems.push({
                'data-test': 'upload-logo',
                label: t('panels.organizations.uploadLogo'),
                id: organizationSlideoutButtonIds.uploadLogo,
                onClick: () => {
                    showImageUploadDialog({
                        title: t('panels.organizations.uploadLogo'),
                        label: t('panels.organizations.logo'),
                        allowedMaxSize: 2097152,
                        previewProps: { maxHeight: 100, maxWidth: 368 },
                        onSave: (blob) => {
                            if (blob) {
                                return organizationAttachmentStorage
                                    .post({
                                    entity: 'organization',
                                    key: 'logo',
                                    entityId: props.organization.id,
                                    content: blob,
                                    contentLength: blob.size,
                                    contentType: blob.type,
                                })
                                    .then(() => {
                                    showInfoSnackbar({ message: t('common.saved') });
                                    storageClientOrganization
                                        .post({ action: 'partial-update', id: props.organization.id, data: { hasLogo: true } })
                                        .then(() => {
                                        props.onReload();
                                    })
                                        .catch(handleErrorSnackbar);
                                })
                                    .catch(handleErrorSnackbar);
                            }
                            else {
                                return Promise.resolve();
                            }
                        },
                    });
                },
            });
        }
        if (allowDelete && props.orgChildrenCount === 0) {
            menuItems.push({
                'data-test': 'delete',
                label: t('common.delete'),
                id: organizationSlideoutButtonIds.delete,
                onClick: () => {
                    showDeleteEntityDialog({
                        entity: t('panels.organizations.entity'),
                        t: t,
                        onConfirm: () => {
                            storageClientOrganization
                                .post({
                                action: 'delete',
                                id: props.organization.id,
                            })
                                .then(() => {
                                showInfoSnackbar({ message: t('common.itemDeleted', { item: props.organization.data.name }) });
                                props.onClose(true);
                            })
                                .catch(handleErrorDialog);
                        },
                    });
                },
            });
        }
    }
    let membership = null;
    if (userState) {
        const user = userState.orgMembership.includes(props.organization.id);
        const orgRole = userState.orgRole[props.organization.id];
        let status;
        for (const s of userState.orgStatus) {
            const [organizationId, userStatus] = s.split('_');
            if (organizationId === props.organization.id) {
                status = userStatus;
            }
        }
        membership = (React.createElement(React.Fragment, null,
            React.createElement(Typography, { sx: (theme) => ({
                    mt: 2,
                    mb: 1,
                    color: theme.palette.text.secondary,
                }), variant: 'h6' }, t('panels.organizations.membership')),
            user && orgRole && (React.createElement(Box, { sx: { display: 'flex', mb: 1 } },
                React.createElement(Typography, { sx: {
                        width: 64,
                        color: (theme) => theme.palette.text.secondary,
                    } }, t('panels.organizations.role')),
                React.createElement(Typography, null, (_e = (_d = orgRoleMap[orgRole]) === null || _d === void 0 ? void 0 : _d.label) !== null && _e !== void 0 ? _e : orgRole))),
            status && (React.createElement(Box, { sx: { display: 'flex', mb: 1 } },
                React.createElement(Typography, { sx: {
                        width: 64,
                        color: (theme) => theme.palette.text.secondary,
                    } }, t('panels.organizations.status')),
                React.createElement(Typography, null, orgStatusMap[status].label))),
            (!status || status === 'withdrawn') && (React.createElement(Button, { "data-test": 'join-organization-button', variant: 'contained', onClick: () => {
                    showConfirmDialog({
                        title: t('panels.organizations.joinOrg'),
                        content: React.createElement(Typography, null, t('panels.organizations.confirmJoinOrg')),
                        confirmLabel: t('common.confirm'),
                        onConfirm: () => {
                            const accountOrgData = getStatusAndRoleInNewOrganization(userState, props.organization.id);
                            let snackbarMessage = t('panels.organizations.requestedToJoin', {
                                name: props.organization.columns.name,
                            });
                            if (requireAnySystemPermission(userState, 'manage-accounts')) {
                                snackbarMessage = t('panels.organizations.joinedOrg', { name: props.organization.columns.name });
                            }
                            storageClientAccount
                                .post({
                                action: 'partial-update',
                                data: accountOrgData,
                                id: userState.id,
                            })
                                .then(() => {
                                showInfoSnackbar({
                                    message: snackbarMessage,
                                    autoHideDuration: 2000,
                                });
                                onStatelessReload()
                                    .then(() => props.onReload())
                                    .catch(handleErrorDialog);
                            })
                                .catch(handleErrorDialog);
                        },
                    });
                } }, t('panels.organizations.join'))),
            status && status !== 'withdrawn' && (React.createElement(Button, { variant: 'contained', onClick: () => {
                    showConfirmDialog({
                        title: t('panels.organizations.leaveOrg'),
                        content: React.createElement(Typography, null, t('panels.organizations.confirmLeaveOrg')),
                        confirmLabel: t('common.confirm'),
                        onConfirm: () => {
                            const statuses = {};
                            const orgRoleMap = Object.assign({}, userState.orgRole);
                            userState.orgStatus.forEach((status) => {
                                const [orgId, userStatus] = status.split('_');
                                statuses[orgId] = userStatus;
                            });
                            statuses[props.organization.id] = 'withdrawn';
                            delete orgRoleMap[props.organization.id];
                            storageClientAccount
                                .post({
                                action: 'partial-update',
                                data: { orgStatus: statuses, orgRole: orgRoleMap },
                                id: userState.id,
                            })
                                .then(() => {
                                showInfoSnackbar({
                                    message: `Left ${props.organization.columns.name}`,
                                    autoHideDuration: 2000,
                                });
                                onStatelessReload()
                                    .then(() => props.onReload())
                                    .catch(handleErrorDialog);
                            })
                                .catch(handleErrorDialog);
                        },
                    });
                } }, t('panels.organizations.leave')))));
    }
    if (organizationTypesIsLoading) {
        return React.createElement(CircularProgress, null);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(ModalSlideoutTopBar, { isOpaque: !props.isScrolledToTop },
            React.createElement(ModalSlideoutTopBarDefaultActions, { menuItems: menuItems, onClose: () => props.onClose(false) })),
        React.createElement(Box, { sx: { display: 'flex', flexDirection: 'column', flex: 1, gap: 0 } },
            React.createElement(ModalSlideoutHeader, { "data-test": 'header', sx: { gap: 1 } },
                React.createElement(ModalSlideoutTitleArea, { titleTypographyVariant: 'h5', title: props.organization.columns.name, "data-test": 'organization-name' }),
                props.organization.data.hasLogo && (React.createElement(Image, { entity: 'organization', entityId: props.organization.id, attachmentKey: 'logo', alt: 'Logo', sx: { display: 'block', height: 100, m: 'auto', mb: 2 }, "data-test": 'organization-img' }))),
            React.createElement(ModalSlideoutContent, { ariaDescribeAllChildren: false },
                React.createElement(Box, { sx: { p: 2 }, "data-test": 'summary' },
                    React.createElement(EntityDetailsSimpleItem, { "data-test": 'contact-name', labelWidth: 120, label: t('panels.organizations.contactName'), text: props.organization.data.contactName }),
                    React.createElement(EntityDetailsSimpleItem, { "data-test": 'contact-phone', labelWidth: 120, label: t('panels.organizations.contactPhone'), text: formatPhoneNumber(props.organization.data.contactPhoneNumber) }),
                    React.createElement(EntityDetailsSimpleItem, { "data-test": 'contact-email', labelWidth: 120, label: t('panels.organizations.contactEmail'), text: props.organization.data.contactEmail }),
                    React.createElement(EntityDetailsSimpleItem, { "data-test": 'address', labelWidth: 120, label: t('panels.organizations.address'), text: props.organization.columns.address }),
                    React.createElement(EntityDetailsSimpleItem, { "data-test": 'description', labelWidth: 120, label: t('panels.organizations.description'), text: props.organization.data.description, lineClamp: 6 }),
                    showOrganizationTypes ? (React.createElement(EntityDetailsSimpleItem, { "data-test": 'organization-type', labelWidth: 120, label: t('panels.organizations.type'), text: getOrganizationTypeName() })) : undefined,
                    organizationStatuses.length > 0 ? (React.createElement(PieChart, { style: { height: '140px', width: '140px' }, data: organizationStatuses, radius: 35, animationDuration: 10, lineWidth: 60, animate: true, label: ({ dataEntry, textAnchor, x, y, style, dy, dx }) => (React.createElement("text", { dominantBaseline: 'central', x: x, y: y, dx: dx, dy: dy, textAnchor: textAnchor, style: style, "data-test-status": dataEntry.title, "data-test-count": dataEntry.value }, dataEntry.value)), labelPosition: 70, paddingAngle: 3, labelStyle: {
                            fill: '#fff',
                            opacity: 0.9,
                            fontSize: '9px',
                            pointerEvents: 'none',
                        } })) : undefined,
                    membership,
                    React.createElement(OrganizationSectionList, { organizationId: props.organization.id, onSelect: props.onEditSection, onShowHistory: props.onHistorySection }))))));
};
